<template>
	<div class="container-prop">
		<div class="propriedades" v-for="(prop, index) in propriedades" :key="index">
			<div class="item texto-modulo" :class="{is_invalid: notValidProps.find(p => p.id === prop.id)}" v-if="!disabled">
				<input :placeholder="prop.nome" v-model="temp[index]" @keyup.enter="addPropsByEnter(`btnAddProp_${prop.nome}`)" :readonly="disabled"/>
				<div class="btn-add">
					<button :id="`btn-add-${index}`" :ref="`btnAddProp_${prop.nome}`" type="button" class="button" :disabled="disableBtnAddProp(temp[index])"
						@click="(e) => addValorProp(index, prop)">Adicionar</button>
				</div>
			</div>

			<div v-for="prop in multiples.filter(pm => pm.id === prop.id)" :key="prop.id" :id="`prop-${prop.nome}`" class="props-add multi">
				<div v-for="(v, i) in prop.data.valor" :key="i"  class="added-prop">
					<div class="valor" :title="v">
						<span class="titulo-prop">{{`${prop.nome} ${i + 1}:`}}</span>
						<span class="valor-prop">{{ `${v}`}}</span>

						<div class="btn-cont">
							<button type="button" class="edit" @click="editarPropriedade({index: i, prop: prop})" :disabled="disabled">
								<i class="fas fa-edit" />
							</button>

							<button type="button" class="remove" @click="removeValueProp({ valueIndex: i, id: prop.id, multiplo: prop.multiplo })" :disabled="disabled">
								<i class="fas fa-trash-alt" />
							</button>
						</div>
					</div>
				</div>
			</div>

			<div v-for="(prop, i) in simples.filter(ps => ps.id === prop.id)" :key="prop.id" :id="`prop-${prop.nome}`" class="props-add simples">
				<div class="added-prop" v-if="prop.data.valor">
					<div class="valor" :title="prop.data.valor">
						<span class="titulo-prop">{{`${prop.nome}`}}:</span>
						<span class="valor-prop">{{ `${prop.data.valor}`}}</span>

						<div class="btn-cont">
							<button type="button" class="edit" @click="editarPropriedade({index: i, prop: prop})" :disabled="disabled">
								<i class="fas fa-edit" />
							</button>

							<button type="button" class="remove" @click="removeValueProp({ id: prop.id, multiplo: prop.multiplo })" :disabled="disabled">
								<i class="fas fa-trash-alt" />
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal-blackscreen" v-if="isModalVisible && !disabled" @close="() => this.isModalVisible = !this.isModalVisible">
			<div class="modal">
				<div class="adicionar">
					<i class="fas fa-plus"></i>
					<p>Atualizar</p>
				</div>
				<input type="text" placeholder="Valor da propriedade" v-model="edited.value" />
				<div class="botoes">
					<button-submit type="button" :onClick="closeModal" class="xs default" style="margin-right: 10px;">Cancelar</button-submit>
					<button-submit type="button" :onClick="() => salvarPropEditada()" class="xs blue">ATUALIZAR</button-submit>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ButtonSubmit from '@/components/shared/ButtonAction'
export default {
	name: 'PropriedadesObjeto',
	components: { ButtonSubmit },
	props: ['propriedades', 'disabled', 'separador'],
	data () {
		return {
			isModalVisible: false,
			edited: {
				index: undefined,
				value: undefined,
				prop: undefined
			},
			temp: []
		}
	},
	computed: {
		...mapGetters(['getPropById', 'propExists', 'multiples', 'simples', 'notValidProps'])
	},
	methods: {
		...mapActions(['editProp', 'addValueProp', 'removeValueProp']),
		addPropsByEnter (el, index) {
			this.$refs[el][0].focus()
			this.$refs[el][0].click()
		},
		addValorProp (index, prop) {
			this.addValueProp({ id: prop.id, value: this.temp[index], multiplo: prop.multiplo })
			this.temp[index] = ''
		},
		editarPropriedade (param) {
			const index = param.index
			const prop = this.getPropById(param.prop.id)
			const value = prop.data.valor
			this.edited.index = index
			this.edited.value = prop.multiplo ? value[index] : value
			this.edited.prop = prop
			this.isModalVisible = !this.isModalVisible
		},
		async salvarPropEditada () {
			this.edited.prop.multiplo
				? this.edited.prop.data.valor[this.edited.index] = this.edited.value
				: this.edited.prop.data.valor = this.edited.value
			this.editProp(this.edited.prop)
			this.isModalVisible = false
		},
		closeModal () {
			this.isModalVisible = false
		},
		disableBtnAddProp (param = '') {
			const regexSeparator = /#{2,}/
			const hasPipe = param.indexOf('|') > -1
			if (param.match(regexSeparator) || hasPipe) {
				return true
			}
			return param.trim().length < 2
		}
	}
}
</script>

<style lang="scss" scoped>
	.container-prop {
		grid-area: form-container-area-6;
		display: grid;
		width: 100%;
		grid-column: 1/5;
		row-gap: 10px;
		.propriedades {
			grid-column: 1/5;
			.item {
				background-color: $inputs-color;
				border-radius: 5px;
				color: #4f5c6b;
				min-height: 50px;
				display: flex;
				align-items: center;
				padding: 0 11px;
				input {
					width: 100%;
					border: none;
					outline: none;
					font-size: .8em;
					background: transparent;
				}
				.button {
					padding: 6px 10px;
					border-radius: 6px;
					background: $main-color;
					color: #fff;
					border: none;
					text-transform: uppercase;
					font-weight: $font-weight-default-bolder;
					font-size: .9em;
					cursor: pointer;
					outline: none;
				}
			}
			.texto-modulo {
				grid-area: form-container-area-5;
				button:disabled {
					background: #dddddd;
					cursor: default;
				}
			}
		}

		.props-add {
			.added-prop{
				margin: 5px 0;

				.valor {
					display: grid;
					grid-template-columns: auto 100px;
					grid-template-areas: 'titulo acoes'
																'valor valor';
					margin-bottom: 10px;
					border-radius: $border-radius;
					font-size: .9em;
					background-color: #F2F2F2;

					& > * {
						padding: 10px;
					}

					.titulo-prop {
						grid-area: titulo;
						align-self: center;
						display: block;
						margin: 5px;
						border-radius: $border-radius;
						font-weight: bold;
						background-color: #8C95AA;
						color: #FFF;
					}

					.valor-prop {
						grid-area: valor;
						display: block;
					}

					.btn-cont{
						grid-area: acoes;
						text-align: center;

						button {
							width: 28px;
							height: 28px;
							border: none;
							border-radius: $border-radius;
							cursor: pointer;
							transition: $transition;
							margin: 5px;

							&[disabled] {
								background-color: #DDD !important;
								cursor: default;
							}

							&.edit {
								background-color: $success-color;
								color: #FFF;

								&:hover {
									background-color: $success-color-darker;
								}
							}

							&.remove {
								background-color: $danger-color;
								color: #FFF;

								&:hover {
									background-color: $danger-color-darker;
								}
							}
						}
					}
				}
			}
		}
	}
</style>

<style lang="scss" scoped>
		.modal-blackscreen {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 2;

			display: flex;
			align-items: center;
			justify-content: center;
			width: 100vw;
			height: 100vh;
			background-color: #0007;

			.modal {
				position: fixed;
				z-index: 1;
				width: 700px;
				min-height: 200px;
				padding: 20px;
				margin: 0 50px auto;
				background-color: #fff;
				color: #000;
				box-shadow: #6667 1px 1px 3px 3px;
				@media only screen and (max-width: 1200px) {
					width: calc(100% - 40px);
				}

				.adicionar {
					display: flex;
					align-items: center;
					margin-bottom: 15px;

					i {
						color: #fff;
						display: flex;
						align-items: center;
						justify-content: center;
						background-color: #1a2738;
						font-size: 19px;
						height: 30px;
						width: 30px;
						margin-right: 6px;
					}

					p {
						color: #1a2738;
						font-weight: bold;
						font-size: 17px;
						text-transform: uppercase;
					}
				}

				input {
					width: 100%;
					padding: 10px;
					margin-top: 10px;
					border: 1px solid #CCC;
					border-radius: 5px;

					&::placeholder {
						text-transform: uppercase;
					}
				}

				.botoes {
					display: flex;
					align-items: flex-end;
					justify-content: flex-end;
					width: 100%;
					margin-top: 30px;

					button {
						width: unset;
						padding-left: 20px;
						padding-right: 20px;
						text-transform: uppercase;
						font-family: 'Roboto', sans-serif;
					}
				}
			}
		}
</style>
